<!--  -->
<template>
  <div class="time_pushbox">
    <!-- <div class="strate_box">
      <div>定时名称：</div>
      <el-input v-model="pushtimevalue" style="width:300px" placeholder="定时名称" />
    </div> -->
    <div class="strate_box">
      <div>选择平台：</div>
      <el-select v-model="promlateid" placeholder="请选择" @change="strategyplatform">
        <el-option
          v-for="item in options"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
    </div>
    <!-- <div class="strate_box">
      <div>保留历史：</div>
      <el-select v-model="savehistoryid" placeholder="请选择">
        <el-option
          v-for="item in savehistory"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
    </div> -->
    <div v-if="promlateid!=null" class="strate_box">
      <div class="title_box">选标签组：</div>
      <el-select v-model="labelgroupid" multiple :disabled="optionsr.length===0" placeholder="请选择" @visible-change="biaoqianzu">
        <el-option
          v-for="item in optionsr"
          :key="item.id"
          :label="item.tag_group_name"
          :value="item.id"
        />
      </el-select>
      <!-- <el-button v-if="labelgroupid" style="margin-left:10px" size="mini" type="primary" @click="labelpreview ">查看标签信息</el-button> -->
    </div>
    <div v-if="promlateid!=null" class="strate_box">
      <div>*多标签组合为并且的关系</div>
    </div>
    <div class="strate_box">
      <div>发送时间：</div>
      <div class="taewr">
        <el-select v-model="hour" filterable placeholder="请选择" style="width:90px">
          <el-option
            v-for="items in houroptions"
            :key="items.value"
            :label="items.label"
            :value="items.value"
          />
        </el-select>
        <div class="tiwmebox">时</div>
      </div>
      <div class="taewr" style="margin-left:10px">
        <el-select v-model="minute" filterable placeholder="请选择" style="width:90px">
          <el-option
            v-for="items in minutesoptions"
            :key="items.value"
            :label="items.label"
            :value="items.value"
          />
        </el-select>
        <div class="tiwmebox">分</div>
      </div>
    </div>
    <div v-if="promlateid!=null" class="strate_box">
      <div>
        选择的消息：
      </div>
      <div>
        {{ messagename }}
      </div>
    </div>
    <el-table
      v-if="promlateid!=null"
      ref="table"
      :key="refreshKey"
      :data="publicAdvelist"
    >
      <el-table-column
        label="选项"
        width="100"
      >
        <template slot-scope="scope">
          <input
            v-model="scope.row.checkboxFlag"
            type="checkbox"
            @click="handleChangeSelectone(scope.$index, scope.row)"
          >
          {{ scope.row.$index }}
        </template>
      </el-table-column>
      <el-table-column
        prop="title"
        label="标题"
        align="center"
      />
      <el-table-column
        prop="real_name"
        label="创建人"
        align="center"
      />
      <el-table-column
        prop="created_at_text"
        label="创建时间"
        align="center"
      />
    </el-table>
    <pagination-right
      v-if="promlateid!=null"
      :total="total"
      :current-page="pageIfon.page"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <div v-if="promlateid!=null" class="strate_box">
      <div>选择公众号：</div>
      <div>
        <el-tag type="warning" @click="chooseaccout">选择公众号</el-tag>
        <el-tag
          v-for="itemr,index in arrs"
          :key="index"
          style="margin-left:10px;margin-bottom:5px"
          closable
          :type="itemr.type"
          @close="rightclick(itemr.id,index)"
        >
          {{ itemr.name }}
        </el-tag>
      </div>
    </div>

    <div>
      <el-button type="primary" size="small" @click="gobackone">返回</el-button>
      <el-button type="primary" size="small" :disabled="savedisabled" @click="btnclick">提交</el-button>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
    >
      <ChooseaccountDialog ref="chhoseaccout" @closedialog="closedialog" />
    </el-dialog>
    <!-- 预览标签组弹窗 -->
    <el-dialog
      title="预览"
      :visible.sync="dialogVisibleser"
      :modal-append-to-body="false"
      :append-to-body="true"
    >
      <Labelgroupdialog ref="labeldialog" :optionsr="optionsr" />
    </el-dialog>
    <!-- 选择公众号弹窗 -->
    <el-dialog
      title="选择预览公众号"
      :visible.sync="lookdialogVisibleser"
      :modal-append-to-body="false"
      :append-to-body="true"
    >
      <lookaccount ref="looklabeldialog" @callbackr="callbackr" />
    </el-dialog>
    <!-- 选择通用的弹窗 -->
    <el-dialog
      title="提示"
      :visible.sync="AandBdialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      :destroy-on-close="true"
    >
      <bandAandB ref="bandAandBview" @saveupdata="saveupdata" />
    </el-dialog>
    <el-dialog
      title="绑定公众号失败列表"
      :visible.sync="erroraccount"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <errorlist ref="errorlistview" @emptyaccount="emptyaccount" />
    </el-dialog>
  </div>
</template>

<script>
import { strategyPlatform, accountlist, timingcreate, adminlist, articlepreview } from '@/api/sourceMaterial.js'
import ChooseaccountDialog from '../timedPush/components/ChooseaccountDialog.vue'
import Labelgroupdialog from '../customerServicelist/components/Labelgroupdialog.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import lookaccount from '../massdispatch/components/lookaccount.vue'
import bandAandB from '../customerServicelist/components/bandAandB.vue'
import errorlist from '../redEnvelopeActivity/components/errorlist.vue'
export default {
  components: {
    ChooseaccountDialog,
    PaginationRight,
    Labelgroupdialog,
    lookaccount,
    bandAandB,
    errorlist
  },
  data() {
    return {
      pushtimevalue: '', // 定时名称
      options: [], // 平台数组
      promlateid: null, // 平台id
      sendtime: null, // 发送时间
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      arrs: [], // 选择公众号数组
      arrsw: [], // 选择公众号数组 id集合
      dialogVisible: false,
      dialogVisibleser: false,
      messagename: '', // 消息名称
      messageid: null, // 消息id
      publicAdvelist: [], // 列表数组
      refreshKey: 0, // 客服消息key
      total: null, // 总页数
      pageIfon: {
        page: 1,
        pageSize: 10,
        platform_id: this.promlateid
      },
      optionsr: [], // 选择标签组数组
      labelgroupid: [], // 标签组id
      wechatnumber: '', // 预览微信号
      radio: 0,
      input: '',
      num: null, // 天数传值
      lookdialogVisibleser: false,
      appid: null,
      app_name: '',
      savehistoryid: null,
      savehistory: [
        {
          id: 1,
          name: '保留'
        },
        {
          id: 2,
          name: '不保留'
        }
      ],
      previewdisbled: false,
      savedisabled: false,
      hour: null,
      minute: null,
      houroptions: [], // 小时数组
      minutesoptions: [], // 分钟数组
      AandBdialogVisible: false,
      erroraccount: false,
      failsarr: [],
      allarr: []
    }
  },

  created() {
    // 初始化时分秒
    this.inittimearr(0, 23, this.houroptions)
    this.inittimearr(0, 59, this.minutesoptions)
    this.getstrategyplatformlist()
    this.optionsr.push({
      id: 0,
      tag_group_name: '全部'
    })
  },
  mounted() {

  },
  methods: {
  // 初始化时分秒
    inittimearr(valone, valtwo, arr) {
      for (let i = valone; i <= valtwo; i++) {
        arr.push({
          value: i,
          label: `${i}`
        })
      }
    },
    // 获取列表
    async getliser() {
      const data = await accountlist(this.pageIfon)
      this.publicAdvelist = data.data.list
      this.publicAdvelist.forEach(item => {
        item.checkboxFlag = false
        if (item.id === this.messageid) {
          item.checkboxFlag = true
        }
      })
      this.total = data.data.total
    },
    saveupdata() {
      this.AandBdialogVisible = false
      this.$router.push({ path: '/masspoLling/index' })
      this.getliser()
    },
    // 客服消息单选
    handleChangeSelectone(index) {
      if (!this.publicAdvelist[index].checkboxFlag) {
        this.messagename = this.publicAdvelist[index].title
        this.messageid = this.publicAdvelist[index].id
      } else {
        // this.selectData = null
      }
      this.publicAdvelist.forEach(item => {
        item.checkboxFlag = false
      })
      this.publicAdvelist[index].checkboxFlag = true
      this.refreshKey = Math.random()
    },
    // 获取策略平台
    async getstrategyplatformlist() {
      const data = await strategyPlatform()
      this.options = data.data.list
    },
    rightclick(id, index) {
      this.arrs.splice(index, 1)
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.chhoseaccout.set(id)
      }, 100)

      console.log(id, index)
    },
    chooseaccout() {
      if (this.promlateid === null) {
        this.$message.error('请选择平台')
        return
      }
      if (this.messagename === '') {
        this.$message.error('请选择消息')
        return
      }
      this.dialogVisible = true
      // eslint-disable-next-line eqeqeq
      // if (this.promlateid == 99) {
      //   setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
      //     this.$refs.chhoseaccout.sendrs(this.promlateid, this.arrs, 2, 1, this.messageid, 3)
      //   }, 100)
      // } else {
      //   setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
      //     this.$refs.chhoseaccout.sendrs(this.promlateid, this.arrs, null, null, this.messageid, 3)
      //   }, 100)
      // }
      // eslint-disable-next-line eqeqeq
      if (this.promlateid == 99) {
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.chhoseaccout.sendrs(this.promlateid, this.arrs, this.messageid, null, 2)
        }, 100)
      } else {
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.chhoseaccout.sendrs(this.promlateid, this.arrs, this.messageid, null, 2)
        }, 100)
      }
    },
    // 选择完公众号 回调
    closedialog(arr) {
      this.arrs = arr
      this.dialogVisible = false
      console.log('arr', arr)
    },
    // // 选择完公众号id回调
    // closedialogone(arr) {
    //   this.arrs = arr
    // },
    // 分页
    fetchPageSize(e) {
      this.pageIfon.pageSize = e
      this.getliser()
    },
    fetchCurrentPage(e) {
      this.pageIfon.page = e
      this.getliser()
    },
    // 提交
    async btnclick() {
      this.arrsw = this.arrs.map(item => {
        return item.id
      })
      console.log('radio', this.radio)
      if (this.promlateid === null) {
        this.$message.error('请选择平台')
        return
      }
      if (this.labelgroupid.length === 0) {
        this.$message.error('请选择标签组')
        return
      }
      if (this.hour === null) {
        this.$message.error('请选择发送小时')
        return
      }
      if (this.minute === null) {
        this.$message.error('请选择发送分钟')
        return
      }

      if (this.arrsw.length === 0) {
        this.$message.error('请选择公众号')
        return
      }
      if (this.messageid === null) {
        this.$message.error('请选择要推送的消息')
        return
      }

      console.log('this.arrsw', this.arrsw)
      this.num = null
      // eslint-disable-next-line eqeqeq
      if (this.radio == 0) {
        this.num = 0
        console.log('否', this.num)
      } else {
        this.num = this.input
        console.log('是', this.num)
      }
      try {
        this.savedisabled = true
        const data = await timingcreate({
          app_ids: this.arrsw,
          articles_template_id: this.messageid,
          hour: this.hour,
          minute: this.minute,
          platform_id: this.promlateid,
          tag_group_ids: this.labelgroupid
        })

        // eslint-disable-next-line eqeqeq
        // if (this.promlateid == 99) {
        //   console.log('选择通用')
        //   this.AandBdialogVisible = true
        //   setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        //     this.$refs.bandAandBview.send(data.data.choosing, this.messageid, this.arrsw, 4, null, this.promlateid, this.labelgroupid, null, this.hour, this.minute)
        //   }, 100)
        // } else {
        //   this.$router.go(-1)
        //   if (data.data.failed.length !== 0) {
        //     this.$message({
        //       type: 'error',
        //       message: `绑定失败的公众号:${data.data.failed.join(',')}`
        //     })
        //   } else {
        //     this.$message({
        //       type: 'success',
        //       message: '新增成功'
        //     })
        //   }
        //   console.log('data', data.data.failed)
        // }
        if (data.code === 204) {
          console.log('绑定有问题', data.data.fails)
          this.savedisabled = false
          this.erroraccount = true
          this.failsarr = []
          this.failsarr = data.data.fails
          this.$nextTick(() => { // 请求成功之后，在这里执行
            this.$refs.errorlistview.send(data.data.fails, 1)
          })
        }
        if (data.data == null) {
          this.$message({
            type: 'success',
            message: `${data.message}`
          })
          this.savedisabled = false
          this.$router.go(-1)
        }
      } catch (e) {
        this.savedisabled = false
        console.log('发生异常:' + e)
      }
    },
    emptyaccount() {
      this.erroraccount = false
      console.log(this.arrs)
      console.log(this.failsarr)
      this.allarr = []
      // eslint-disable-next-line eqeqeq
      this.allarr = this.arrs.filter(x => this.failsarr.every(y => y.app_id != x.id))
      console.log('this.allarr', this.allarr)
      this.arrs = this.allarr
      this.dialogVisible = true
      console.log('this.arrs', this.arrs)
      // eslint-disable-next-line eqeqeq
      // if (this.promlateid == 99) {
      //   setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
      //     this.$refs.chhoseaccout.sendrs(this.promlateid, this.allarr, 2, 1)
      //   }, 100)
      // } else {
      //   setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
      //     this.$refs.chhoseaccout.sendrs(this.promlateid, this.allarr)
      //   }, 100)
      // }
      // eslint-disable-next-line eqeqeq
      if (this.promlateid == 99) {
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.chhoseaccout.sendrs(this.promlateid, this.allarr, this.messageid, null, 2)
        }, 100)
      } else {
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.chhoseaccout.sendrs(this.promlateid, this.allarr, this.messageid, null, 2)
        }, 100)
      }
    },
    getDifference(arr1, arr2) {
      return arr1.concat(arr2).filter(function(item, i, arr) {
        return arr.indexOf(item) === arr.lastIndexOf(item)
      })
    },
    // 返回
    gobackone() {
      this.$router.go(-1)
    },
    async strategyplatform(val) {
      const data = await adminlist({
        page: 1,
        page_size: 50,
        platform_id: val
      })
      this.optionsr = []
      this.optionsr = data.data.list
      if (this.labelgroupid !== 0) {
        this.labelgroupid = null
      }
      this.optionsr.unshift({
        id: 0,
        tag_group_name: '全部'
      })
      this.labelgroupid = []
      this.arrs = []
      this.pageIfon.page = 1
      this.pageIfon.platform_id = val// 获取消息列表 给id赋值
      this.getliser()// 调用消息列表
      this.messagename = ''
      this.messageid = null
      console.log('data', data)
    },
    // 预览标签组
    labelpreview() {
      this.dialogVisibleser = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.labeldialog.labelsend(this.labelgroupid)
      }, 100)
    },
    chaer() {
      if (this.input < 0) {
        this.input = 1
      }
      // 判断不能输入小数点
      const str = '' + this.input
      if (str.indexOf('.') !== -1) {
        console.log('小鼠了')
        this.input = 1
      }
      if (this.input > 7) {
        this.input = 7
      }
    },
    chooserw() {
      if (this.promlateid === null) {
        this.$message.error('请选择平台')
        return
      }
      this.lookdialogVisibleser = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.looklabeldialog.send(this.promlateid)
      }, 100)
    },
    callbackr(item) {
      this.lookdialogVisibleser = false
      this.appid = item.app_id
      this.app_name = item.account_name
    },
    previewaccount() {
      if (this.messageid === null) {
        this.$message.error('请选择要预览的消息')
        return
      }
      if (this.wechatnumber === '') {
        this.$message.error('请输入微信openid')
        return
      }
      if (this.appid === null) {
        this.$message.error('请选择预览的微信公众号')
        return
      }
      this.previewdisbled = true
      articlepreview({
        articles_template_id: this.messageid,
        app_id: this.appid,
        preview_wechat_no: this.wechatnumber
      }).then((res) => {
        this.previewdisbled = false
        this.$message({
          type: 'success',
          message: '预览成功，请查看手机'
        })
      }).catch(err => {
        console.log(err)
        this.previewdisbled = false
      })
    },
    biaoqianzu() {
      console.log('this.labelgroupid', this.labelgroupid)
      for (let i = 0; i < this.labelgroupid.length; i++) {
        if (this.labelgroupid[i] === 0) {
          this.labelgroupid = [0]
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
/* @import url(); 引入css类 */
.time_pushbox{
  padding: 20px;
}
.strate_box{
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  gap:10px;
  div{
    flex-shrink: 0;
    font-size: 14px;
    color: #606266;
  }
   span{
      margin-left: 10px;
   }
}
  .taewr{
    display: flex;
    align-items: center;
  }
  .tiwmebox{
    width: 50px;
    background: #f4f7f7;
    height: 36px;
    border: 1px solid #cccccc;
    border-left: 0px;
    text-align: center;
    line-height: 36px;
    color: #61686b;
    border-radius: 0px 5px 5px 0px;

  }
</style>
